import { Snackbar, Alert } from "@mui/material";

export default function AppSnackbar({
  open,
  message,
  severity = "info", // success | error | warning | info
  autoHideDuration = 3000,
  onClose,
  anchorOrigin = { vertical: "top", horizontal: "center" }
}) {
  const handleClose = (_, reason) => {
    if (reason === "clickaway") return;
    onClose?.();
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      anchorOrigin={anchorOrigin}
      style={{ marginTop: "5%" }}
    >
      <Alert
        onClose={handleClose}
        severity={severity}
        sx={{ width: '100%' }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}